import React, { FC } from 'react';
import styles from './styles.module.css';
import { usePostRegisterCsvByWorkTimeMutation } from '../../api/workTimeApi';
import Button from '../common/Button';
import { usePostRegisterCsvByCompanyMutation } from '../../api/companyApi';
import { usePostRegisterCsvByCarMutation } from '../../api/carApi';
import { usePostRegisterCsvByDriverMutation } from '../../api/driverApi';

const useEditCsv = (type: CsvType) => {
  const workTimesCsvHookItem = usePostRegisterCsvByWorkTimeMutation();
  const companyCsvHookItem = usePostRegisterCsvByCompanyMutation();
  const carCsvHookItem = usePostRegisterCsvByCarMutation();
  const driverCsvHookItem = usePostRegisterCsvByDriverMutation();
  switch (type) {
    case 'workTimes':
      return workTimesCsvHookItem;
    case 'company':
      return companyCsvHookItem;
    case 'car':
      return carCsvHookItem;
    case 'driver':
      return driverCsvHookItem;
  }
};

type CsvType = 'workTimes' | 'company' | 'car' | 'driver';
type Props = {
  type: CsvType;
  disabled?: boolean;
};
const CsvInput: FC<Props> = ({ type, disabled }) => {
  const [editCsv] = useEditCsv(type);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      editCsv(file);
    }
  };

  return (
    <Button variants={['cancel', 'contain']} disabled={disabled}>
      <label htmlFor="form-image">
        CSV一括登録
        <input
          className={styles.formImage}
          type="file"
          id="form-image"
          onChange={(e) => {
            handleFileChange(e);
            e.target.value = '';
          }}
          disabled={disabled}
        />
      </label>
    </Button>
  );
};

export default CsvInput;
